import Icons from './Icons.vue';

export default Icons;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/result/components/progress/components/icons/index.ts